import { createTheme, Theme } from '@mui/material';

import { palette } from '@/styles/theme/colors';
import { components } from '@/styles/theme/components';
import { typography } from '@/styles/theme/typography';

const theme: Theme = createTheme({
  typography,
  spacing: 2, // mb(3) -> 3 * 2 -> 6,
  palette,
  components
});

export default theme;
